<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap">
      <v-flex class="pa-0 login_content">
        <ValidationObserver ref="observer">
          <v-form
            v-model="valid"
            lazy-validation
          >
            <v-card class="login_form" flat>
              <div class="bg_type">
                <h2 class="top_title d-flex align-center">
                  <div><h3 class="top_sub_title mt--5">{{ $t('signin.strong_auth.fields.login_with_strong_authentication') }}</h3></div>
                  <v-spacer></v-spacer>
                  <v-img style="max-width:130px;cursor:pointer;" width="130" src="~@/assets/img/header_logo2.png" alt="EGPO" @click="$router.push('/main')"></v-img>
                </h2>
                <v-card-text class="pa-0 mt-25 login_form_innner_box">
                  <v-row class="ma-0">
                    <!-- Method -->
                    <v-col cols="12" class="pa-0 mb-15">
                      <h2 class="title">{{$t('signin.strong_auth.fields.method')}}</h2>
                      <v-select
                        v-model="strong_auth_type_code"
                        :items="$vuetify.rtl ? strongAuthTypeCodeListAr : strongAuthTypeCodeListEn"
                        solo
                        flat
                        outlined
                        dense
                        disabled
                        class="select_h48 login_select_box"
                      ></v-select>
                    </v-col>

                    <v-col cols="12" class="pa-0 mb-15">
                      <h2 class="title">{{ otpCodeText }}</h2>
                      <ValidationProvider v-slot="{ errors }" name="OTP Code" :rules="{required: true}">
                        <v-text-field
                          v-model="pin_code"
                          label=""
                          solo
                          flat
                          outlined
                          dense
                          class="login_text_filed type_h48 round5"
                          maxlength="6"
                          ref="pin"
                          :error-messages="errors"
                          append-icon="mdi-alert"
                          @keyup.enter="fnSignIn()"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0 mt--5">
                  <v-btn color="white" class="sign_in_btn" text @click="fnSignIn()">{{$t('signin.strong_auth.fields.signin')}}</v-btn>
                </v-card-actions>

                <v-row class="ma-0 mt-15">
                  <v-btn
                    v-if="strong_auth_type_code == '3703'"
                    class="btn_small_text forget_btn"
                    text
                    @click="fnSendOtpMail()"
                  >
                    {{$t('signin.strong_auth.fields.reset_google_otp')}}
                  </v-btn>
                  <v-btn
                    v-if="strong_auth_type_code == '3702'"
                    class="btn_small_text forget_btn"
                    text
                    @click="fnSendPinCodeMail()"
                  >
                    {{$t('signin.strong_auth.fields.reset_pin_code')}}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-row>
              </div>
            </v-card>
          </v-form>
        </ValidationObserver>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import store from '@/store'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import utils from '@/utils/utils'

export default {
  name: 'StrongAuth',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data () {
    return {
      strong_auth_type_code: this.$route.params.strong_auth_type_code,
      strongAuthTypeCodeListAr: [],
      strongAuthTypeCodeListEn: [],
      pin_code: '',
      textfd : true,
      valid :true,
      otpCodeText : this.$t('signin.strong_auth.fields.otp_code'),
      params: this.$route.params,

      return_url : ''
    }
  },
  created () {
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      this.$refs.pin.focus()

      // route.params 값이 없으면
      if (this.strong_auth_type_code === '') {
        this.$router.push('/signin')
      }

      if (this.strong_auth_type_code === '3702') {
        this.otpCodeText = this.$t('signin.strong_auth.fields.pin_code')
      } else {
        this.otpCodeText = this.$t('signin.strong_auth.fields.otp_code')
      }

      let options = {
        upper_code: '3700',
        remove: [{code : '3701'}]
      }
      utils.fnGetCodeList(options).then(list => {
        this.strongAuthTypeCodeListAr = list.ar
        this.strongAuthTypeCodeListEn = list.en
      })

    },
    // Sign In 처리
    fnSignIn () {
      this.$refs.observer.validate().then((valid) => {
        if (valid) {
          let params = {
            seq: this.params.seq,
            strong_auth_type_code: this.strong_auth_type_code,
            pin_code: this.pin_code
          }

          requestApi({
            url: '/autho/user/strongauth',
            method: 'POST',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                store.dispatch('SetAuthHeader', res.data.access_token)
                store.dispatch('SetToken', res.data)

                if (res.data.ind_update_cert !== 'N' && (
                    res.data.user_status_type_code === '3506' ||
                    res.data.user_status_type_code === '3508' ||
                    res.data.user_status_type_code === '3530' ||
                    res.data.user_status_type_code === '3532')) {
                  let option = {
                    text: this.$t('signin.proof_document.fields.title_msg')
                  }
                  eventBus.$emit('SHOW_SNACKBAR', option)

                  this.$router.push('/signin/proofdocument')
                } else {
                  if (utils.isNull(this.$route.params.return_url)){
                    this.$router.push('/dashboard')
                  } else {
                    this.$router.push(decodeURIComponent(this.$route.params.return_url))
                  }
                }
              } else {
                let option = {
                  text: this.$vuetify.rtl ? res.res_msg_ar : res.res_msg_en
                }
                eventBus.$emit('SHOW_SNACKBAR', option)
              }
            }
          })
        }
      })
    },
    fnSendOtpMail(){
      let params = {
        email : this.$route.params.email
      }

      requestApi({
        url: '/autho/resetgoogleotp',
        method: 'POST',
        data: params,
        callback: (res) => {
          let option = {
            text : (this.$vuetify.rtl) ? res.res_msg_ar : res.res_msg_en,
            timeout : 5000
          }
          eventBus.$emit('SHOW_SNACKBAR', option)
        }
      })
    },
    fnSendPinCodeMail(){
      let params = {
        email : this.$route.params.email
      }
      requestApi({
        url: '/autho/resetpincode',
        method: 'POST',
        data: params,
        callback: (res) => {
          let option = {
            text : (this.$vuetify.rtl) ? res.res_msg_ar : res.res_msg_en,
            timeout : 5000
          }
          eventBus.$emit('SHOW_SNACKBAR', option)
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
